var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowroundzoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 15.4166H18.1608L15.9554 17.622C15.9156 17.6604 15.8839 17.7064 15.862 17.7573C15.8402 17.8081 15.8287 17.8628 15.8282 17.9181C15.8278 17.9734 15.8383 18.0283 15.8592 18.0795C15.8802 18.1307 15.9111 18.1772 15.9503 18.2163C15.9894 18.2555 16.0359 18.2864 16.0871 18.3074C16.1383 18.3283 16.1932 18.3388 16.2485 18.3384C16.3038 18.3379 16.3585 18.3264 16.4093 18.3046C16.4602 18.2827 16.5062 18.251 16.5446 18.2112L19.4613 15.2945C19.5394 15.2164 19.5833 15.1104 19.5833 14.9999C19.5833 14.8894 19.5394 14.7835 19.4613 14.7053L16.5446 11.7887C16.466 11.7128 16.3608 11.6708 16.2515 11.6717C16.1423 11.6727 16.0378 11.7165 15.9605 11.7938C15.8832 11.871 15.8394 11.9755 15.8385 12.0848C15.8375 12.194 15.8795 12.2993 15.9554 12.3778L18.1608 14.5833H10.8333C10.7228 14.5833 10.6169 14.6272 10.5387 14.7053C10.4606 14.7834 10.4167 14.8894 10.4167 14.9999C10.4167 15.1104 10.4606 15.2164 10.5387 15.2946C10.6169 15.3727 10.7228 15.4166 10.8333 15.4166Z",
    fill: "#FF6000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowroundzoom);
export default __webpack_public_path__ + "static/media/arrowroundzoom.f03ae9cc0d6cc6a7986d1d5f023ac145.svg";
export { ForwardRef as ReactComponent };